import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as BatchActions from '../batches.actions';
import * as Actions from './batches.grid.actions';

const initialState = {
  batchRows: emptyArray,
  isLoading: true,
  sortBy: 'CreatedDateAsc',
  searchTerm: '',
};

const makeSetIsLoading = (isLoading) => {
  return (state) => ({
    ...state,
    isLoading,
  });
};

const onClearBatchFromRow = (state, batchIds) => {
  const filteredBatchRows = state.batchRows.filter((rows) => {
    return batchIds.indexOf(rows.fulfillmentPlanSetId) < 0;
  });
  return {
    ...state,
    batchRows: filteredBatchRows,
  };
};

const actionHandlerMap = {
  [Actions.BATCH_ROW_SET_ACTIVE]: (state, { batchData }) => {
    const batchRows = get(batchData, 'pageData', emptyArray);
    return {
      ...state,
      batchRows,
      selectedBatches: emptyArray,
    };
  },
  [Actions.SET_SELECTED_BATCHES_BY_IDS]: (state, { fulfillmentPlanSetIds }) => {
    return {
      ...state,
      selectedBatches: state.batchRows.filter((batch) => fulfillmentPlanSetIds.indexOf(batch.fulfillmentPlanSetId) !== -1),
    };
  },
  [Actions.ARCHIVE_BATCHES_REQUEST]: makeSetIsLoading(true),
  [Actions.GET_BATCH_ROW_REQUEST]: makeSetIsLoading(true),
  [Actions.ARCHIVE_BATCHES_FAILURE]: makeSetIsLoading(false),
  [Actions.GET_BATCH_ROW_SUCCESS]: makeSetIsLoading(false),
  [Actions.GET_BATCH_ROW_FAILURE]: makeSetIsLoading(false),
  [Actions.UPDATE_BATCH_GRID_SORTING]: (state, { sortBy }) => ({
    ...state,
    sortBy,
  }),
  [Actions.UPDATE_FILTER_SEARCH_TERM]: (state, { searchTerm }) => ({
    ...state,
    searchTerm,
  }),
  [BatchActions.CLEAR_BATCH]: (state, { batchIds }) => onClearBatchFromRow(state, batchIds),
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './batches.grid.reducer.metadata';
